import config from "../config";


export function templateReplace(userNo, templateId) {
  return config.baseURL + '/templateReplace/paramReplace?userNo=' + userNo + "&templateId=" + templateId
}




// WEBPACK FOOTER //
// ./src/http/modules/replace.js